import React, { useState } from 'react'

import Modal from '../../components/Modal'
import { getMeterIcon } from '../Dashboard'
import {ConfirmButton} from '../../components/BasicButton'
import "../assets/scss/DashboardSettings.scss"

/**
 * @typedef Props
 * @property {import('../Dashboard').Dashboard} Props.dashboard
 * @property {import('../Dashboard').ViewPreferences} Props.viewPreferences
 * @property {(newOrder: string[]) => void} Props.onClose
 */

/**
 * @param {Props} props 
 */
export function DashboardSettingsModal(props) {
    const [viewPreferences, setViewPreferences] = useState(props.viewPreferences)
    const [draggingMeterId, setDraggingMeterId] = useState()

    const meterOrder = viewPreferences.order

    const buttons = meterOrder
        .filter(id => props.dashboard.meters.find(meter => meter.obj_id === id))
        .map(id => props.dashboard.meters.find(meter => meter.obj_id === id))
        .map(meter => renderButton(meter))

    function renderButton(meter) {
        const meterSize = getMeterSize(meter.obj_id) + 1
        return <div
                key={meter.obj_id}
                className="box element-set-v dashboard-settings_draggable"
                style={{
                    gridColumn: `span ${meterSize} / span ${meterSize}`
                }}
                draggable
                onDragStart={e=> onDragStart(e, meter)}
                onDragOver={e => onDragOver(e, meter)}
                onDrop={e => onDrop(e, meter)}
                onClick={(e) => {
                    e.preventDefault()
                    changeMeterSize(meter.obj_id)
                }}
            >
            <img
                src={getMeterIcon(meter.obj_type)}
                draggable={false}
                alt={meter.obj_type}
            />
            <span>{meter.text}</span>
            {meter.project_settings.text ? <span className={"text-xs"}>{meter.project_settings.text }</span> : null}
        </div>
    }

    /**
     * @param {DragEvent} e 
     * @param {Meter} meter 
     */
    function onDragStart(e, meter) {
        e.dataTransfer.setData('text', meter.text)
        setDraggingMeterId(meter.obj_id)
    }

    /**
     * @param {DragEvent} e 
     * @param {Meter} meter 
     */
    function onDragOver(e, meter) {
        if (draggingMeterId !== meter.obj_id) {
            e.preventDefault()
        }
    }

    /**
     * @param {DragEvent} e 
     * @param {Meter} meter 
     */
    function onDrop(e, meter) {
        e.stopPropagation()
        const newOrder = rearrangeOrder(meterOrder, draggingMeterId, meter.obj_id)

        setViewPreferences(viewPreferences => ({
            ...viewPreferences,
            order: newOrder,
        }))
    }

    /**
     * @param {string[]} order 
     * @param {string} draggingId 
     * @param {string} droppingAfterId 
     */
    function rearrangeOrder(order, draggingId, droppingAfterId) {
        const currentIndex = order.findIndex(id => id === draggingId)
        const newOrder = order.filter(id => id !== draggingId)
        const afterIndex = newOrder.findIndex(id => id === droppingAfterId)

        if (currentIndex === afterIndex + 1) {
            newOrder.splice(afterIndex, 0, draggingId)
        } else if (afterIndex >= 0) {
            // when dropping 2nd on top of first set as first - normally after
            const setBefore = currentIndex === 1 && afterIndex === 0
            newOrder.splice(setBefore ? afterIndex : afterIndex + 1, 0, draggingId)
        }

        return newOrder
    }

    /**
     * @param {string} meterId 
     */
    function getMeterSize(meterId) {
        return viewPreferences.config[meterId]?.size ?? 0
    }

    /**
     * @param {string} meterId 
     */
    function changeMeterSize(meterId) {
        const currentSize = getMeterSize(meterId)
        const newSize = (currentSize + 1) % 3

        setViewPreferences(viewPreferences => ({
            ...viewPreferences,
            config: {
                ...viewPreferences.config,
                [meterId]: {
                    ...viewPreferences.config[meterId],
                    size: newSize,
                },
            },
        }))
    }

    return <Modal header="Asetukset" onClose={() => props.onClose(viewPreferences)} showCloseButton>
        <section>
            <p>Vaihda kuvaajan paikkaa raahaamalla. Muuta leveyttä klikkaamalla.</p>
            <div className="grid-container grid-1 grid-3_lg">
                {buttons}
            </div>
        </section>
        <footer className={"popup-footer"}>
            <div className={"btn-set"}>
                <ConfirmButton
                    label={"Valmis"}
                    action={()=> props.onClose(viewPreferences)}
                />
            </div>
        </footer>
    </Modal>
}
